import React, { useState } from 'react';
import { Calendar, CheckCircle, User, Clock, Sparkles, ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { MobileLayout } from '../components/MobileLayout';
import { PianificaPuliziaWizard } from '../components/PianificaPuliziaWizard';
import { Tabs } from '../components/ui/Tabs';
export function PuliziePage() {
  const [isWizardOpen, setIsWizardOpen] = useState(false);
  const [activeTab, setActiveTab] = useState<'gestione' | 'opportunita'>('gestione');
  // Mock data for upcoming cleanings
  const prossimePulizie = [{
    id: '1',
    property: 'Villa Sunset',
    date: 'Mer 17 Gen',
    time: '11:00 - 15:00',
    status: 'in_corso',
    cleaner: 'Francesca N.',
    cleanerImg: 'https://cdn.magicpatterns.com/uploads/g4qUZyyXcdzW3wf29pvDcz/Screenshot_2026-03-22_alle_16.12.18.png',
    isShareable: true
  }, {
    id: '2',
    property: 'Villa Sunset',
    date: 'Ven 19 Gen',
    time: '12:00 - 14:30',
    status: 'pianificata',
    cleaner: 'Roberto F.',
    cleanerImg: '',
    isShareable: false
  }];
  // Mock data for completed cleanings
  const pulizieCompletate = [{
    id: '3',
    property: 'Villa Sunset',
    date: 'Lun 15 Gen',
    duration: '3h 30min',
    cleaner: 'Francesca N.',
    aiScore: 98,
    isShareable: true
  }, {
    id: '4',
    property: 'Villa Sunset',
    date: 'Ven 12 Gen',
    duration: '4h',
    cleaner: 'Roberto F.',
    aiScore: 100,
    isShareable: false
  }];
  const shareableProssime = prossimePulizie.filter(p => p.isShareable);
  const shareableCompletate = pulizieCompletate.filter(p => p.isShareable);
  const totalShareable = shareableProssime.length + shareableCompletate.length;
  return <MobileLayout data-id="element-3432">
      {/* Header */}
      <div className="flex items-center justify-between mb-5" data-id="element-3433">
        <h1 className="text-xl lg:text-2xl font-bold text-foreground" data-id="element-3434">
          Pulizie
        </h1>
      </div>

      {/* Tabs */}
      <Tabs className="mb-6" value={activeTab} onValueChange={id => setActiveTab(id as 'gestione' | 'opportunita')} items={[{
      id: 'gestione',
      label: 'Gestione'
    }, {
      id: 'opportunita',
      label: 'Opportunità',
      badge: totalShareable > 0 ? <span className="inline-flex items-center justify-center min-w-[18px] h-[18px] px-1 text-[10px] font-bold bg-coral text-white rounded-full" data-id="element-3436">
                  {totalShareable}
                </span> : undefined
    }]} data-id="element-3435" />

      {/* TAB: Gestione */}
      {activeTab === 'gestione' && <>
          {/* In corso / Prossime */}
          <div className="mb-8" data-id="element-3437">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3438">
              In corso e prossime
            </div>

            <div className="space-y-3" data-id="element-3439">
              {prossimePulizie.map(pulizia => {
            const isInProgress = pulizia.status === 'in_corso';
            return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3440">
                    <div className="flex justify-between items-start mb-3" data-id="element-3441">
                      <div data-id="element-3442">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3443">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3444">
                          <span className="flex items-center gap-1" data-id="element-3445">
                            <Calendar size={12} data-id="element-3446" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3447">
                            <Clock size={12} data-id="element-3448" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3449">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3450">
                      <div className="flex items-center gap-2" data-id="element-3451">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3452" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3453">
                            <User size={14} className="text-muted-foreground" data-id="element-3454" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3455">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3456" />
                    </div>
                  </Link>;
          })}
            </div>
          </div>

          {/* Completate */}
          <div className="mb-6" data-id="element-3457">
            <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3" data-id="element-3458">
              Completate di recente
            </div>

            <div className="space-y-3" data-id="element-3459">
              {pulizieCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3460">
                  <div data-id="element-3461">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3462">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3463">
                      <span className="flex items-center gap-1" data-id="element-3464">
                        <Calendar size={12} data-id="element-3465" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3466">
                        <Clock size={12} data-id="element-3467" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3468">
                    <div className="flex flex-col items-end" data-id="element-3469">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3470">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3471">
                        <CheckCircle size={12} data-id="element-3472" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3473" />
                  </div>
                </Link>)}
            </div>
          </div>
        </>}

      {/* TAB: Opportunità */}
      {activeTab === 'opportunita' && <div className="mb-8" data-id="element-3474">
          <div className="text-xs text-muted-foreground uppercase tracking-wider font-medium mb-3 flex items-center gap-1.5" data-id="element-3475">
            <Sparkles size={12} className="text-coral" data-id="element-3476" />
            Pulizie condivisibili
          </div>

          {totalShareable === 0 ? <div className="bg-white border border-border rounded-xl p-8 text-center" data-id="element-3477">
              <p className="text-sm text-muted-foreground" data-id="element-3478">
                Nessuna pulizia condivisibile al momento.
              </p>
            </div> : <div className="space-y-3" data-id="element-3479">
              {shareableProssime.map(pulizia => {
          const isInProgress = pulizia.status === 'in_corso';
          return <Link key={pulizia.id} to={`/pulizia-dettaglio?status=${isInProgress ? 'in_corso' : 'pianificata'}`} className="block bg-white border border-border rounded-xl p-4 hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3480">
                    <div className="flex justify-between items-start mb-3" data-id="element-3481">
                      <div data-id="element-3482">
                        <h3 className="text-sm font-semibold text-foreground" data-id="element-3483">
                          {pulizia.property}
                        </h3>
                        <div className="flex items-center gap-3 mt-1 text-xs text-muted-foreground" data-id="element-3484">
                          <span className="flex items-center gap-1" data-id="element-3485">
                            <Calendar size={12} data-id="element-3486" />
                            {pulizia.date}
                          </span>
                          <span className="flex items-center gap-1" data-id="element-3487">
                            <Clock size={12} data-id="element-3488" />
                            {pulizia.time}
                          </span>
                        </div>
                      </div>
                      <span className={`text-[10px] font-medium px-2 py-1 rounded-full border ${isInProgress ? 'bg-coral/5 text-coral border-coral/20' : 'bg-muted text-muted-foreground border-border'}`} data-id="element-3489">
                        {isInProgress ? '● In corso' : 'Pianificata'}
                      </span>
                    </div>

                    <div className="flex items-center justify-between" data-id="element-3490">
                      <div className="flex items-center gap-2" data-id="element-3491">
                        {pulizia.cleanerImg ? <img src={pulizia.cleanerImg} alt={pulizia.cleaner} className="w-7 h-7 rounded-full object-cover" data-id="element-3492" /> : <div className="w-7 h-7 rounded-full bg-muted flex items-center justify-center" data-id="element-3493">
                            <User size={14} className="text-muted-foreground" data-id="element-3494" />
                          </div>}
                        <span className="text-xs text-muted-foreground" data-id="element-3495">
                          {pulizia.cleaner}
                        </span>
                      </div>
                      <ChevronRight size={16} className="text-muted-foreground" data-id="element-3496" />
                    </div>
                  </Link>;
        })}

              {shareableCompletate.map(pulizia => <Link key={pulizia.id} to="/pulizia-dettaglio?status=completata" className="bg-white border border-border rounded-xl p-4 flex items-center justify-between hover:border-foreground/20 hover:shadow-sm transition-all cursor-pointer" data-id="element-3497">
                  <div data-id="element-3498">
                    <h3 className="text-sm font-medium text-foreground mb-1" data-id="element-3499">
                      {pulizia.property}
                    </h3>
                    <div className="flex items-center gap-3 text-xs text-muted-foreground" data-id="element-3500">
                      <span className="flex items-center gap-1" data-id="element-3501">
                        <Calendar size={12} data-id="element-3502" />
                        {pulizia.date}
                      </span>
                      <span className="flex items-center gap-1" data-id="element-3503">
                        <Clock size={12} data-id="element-3504" />
                        {pulizia.duration}
                      </span>
                    </div>
                  </div>

                  <div className="flex items-center gap-4" data-id="element-3505">
                    <div className="flex flex-col items-end" data-id="element-3506">
                      <span className="text-[10px] text-muted-foreground uppercase tracking-wider font-medium mb-0.5" data-id="element-3507">
                        AI Check
                      </span>
                      <span className="inline-flex items-center gap-1 text-xs font-bold text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md border border-emerald-100" data-id="element-3508">
                        <CheckCircle size={12} data-id="element-3509" />
                        {pulizia.aiScore}/100
                      </span>
                    </div>
                    <ChevronRight size={16} className="text-muted-foreground" data-id="element-3510" />
                  </div>
                </Link>)}
            </div>}
        </div>}

      {/* Wizard Modal */}
      <PianificaPuliziaWizard isOpen={isWizardOpen} onClose={() => setIsWizardOpen(false)} data-id="element-3511" />
    </MobileLayout>;
}